/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_PhoneInputs */

const en_guest_book_phone = /** @type {(inputs: Guest_Book_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

const pl_guest_book_phone = /** @type {(inputs: Guest_Book_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Guest_Book_PhoneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_phone = /** @type {((inputs?: Guest_Book_PhoneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_PhoneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_phone(inputs)
	return en_guest_book_phone(inputs)
});